import React, { useState } from 'react';
import Input from 'components/common/form/input/Input';
import { Form, Formik } from 'formik';
import { Alert, Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import * as Yup from 'yup';
import Button from 'components/base/Button';
import LinkExpiredModal from 'components/modals/LinkExpiredModal';
import { useNavigate } from 'react-router-dom';
import { ForgotPasswordProp, Props } from './resetForgottenPassword.type';
import useResetPassword from './hook/useResetPassword.tsx';
import ResetPasswordModal from 'components/modals/ResetPasswordModal';

const validationSchema = Yup.object().shape({
  password: Yup.string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters long')
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/,
      'Password must contain at least one letter and one number'
    ),

  confirmPassword: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref('password')], 'Passwords must match')
});

function ResetForgottenPassword({ token }: Props) {
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const navigate = useNavigate();
  const { isLoading, isError, resetPassword, errorMessage } =
    useResetPassword(token);

  const navigateToSignin = () => {
    navigate('/sign-in');
  };

  const handleSubmit = ({ password, confirmPassword }: ForgotPasswordProp) => {
    resetPassword({ password, confirmPassword }, () => {
      setIsSuccess(true);
    });
  };

  return (
    <div>
      <LinkExpiredModal show={isError} handleSubmit={navigateToSignin} />
      <ResetPasswordModal handleSubmit={navigateToSignin} show={isSuccess} />
      <Formik
        initialValues={{
          password: '',
          confirmPassword: ''
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        <Form>
          <Row className="g-4 justify-content-center">
            {typeof errorMessage === 'string' && (
              <Col xs={10}>
                <Alert variant="subtle-danger" className="p-2">
                  {errorMessage}
                </Alert>
              </Col>
            )}
            <Col xs={10}>
              <FormGroup className="text-start">
                <FormLabel htmlFor="password">Password</FormLabel>
                <Input name="password" id="password" type="password" />
              </FormGroup>
            </Col>
            <Col xs={10}>
              <FormGroup className="text-start">
                <FormLabel htmlFor="confirmPassword">
                  Confirm Password
                </FormLabel>
                <Input
                  name="confirmPassword"
                  id="confirmPassword"
                  type="password"
                />
              </FormGroup>
            </Col>
          </Row>
          <footer className="mt-4 d-flex justify-content-center">
            <Button
              variant="primary"
              type="submit"
              loading={isLoading}
              loadingPosition="start"
            >
              Reset
            </Button>
          </footer>
        </Form>
      </Formik>
    </div>
  );
}

export default ResetForgottenPassword;
